UAEditRBACRoleCtrl.$inject = ['user', 'userInfo', 'adminApi', '$uibModalInstance']

export default function UAEditRBACRoleCtrl(user, userInfoService, adminApi, $modalInstance) {
  this.selectedRole = userInfoService.userInfo.rbac_role
  this.availableRoles = ['writer', 'editor', 'publisher']
  this.saveRole = function(role) {
    if (role) {
      adminApi.postUserRBACRole(user.email, role).then(
        function(result) {
          $modalInstance.close(result)
          userInfoService.userInfo.rbac_role = result.role
        }.bind(this),
        function(reason) {
          this.showError = true
          this.errorMessage = reason
        }.bind(this)
      )
    } else {
      adminApi.deleteUserRBACRole(user.email, userInfoService.userInfo.rbac_role).then(
        function(result) {
          $modalInstance.close(result)
          delete userInfoService.userInfo.rbac_role
        }.bind(this),
        function(reason) {
          this.showError = true
          this.errorMessage = reason
        }.bind(this)
      )
    }
  }
}
